import { ProductUsageBreakdownDateResolution } from '../product-usage-breakdown-chart-types/product-usage-breakdown-date-resolution';
import { UsageByDateBreakdown } from '@vy/types';
import { normalizeUsageDataByDateResolution } from './product-usage-breakdown-normalizer/usage-by-date-normalizer';
import { NormalizedProductUsageDataBreakdown } from './product-usage-breakdown-normalizer/normalized-product-usage-data-breakdown';
import { PRODUCT_USAGE_CHART_DATA_KEY } from '../product-usage-breakdown-chart-types/product-usage-chart-data-key';
import { buildDateProductUsageChartDataItem } from './build-date-product-usage-chart-data';

export function buildProductUsageChartData(
  usageByDateBreakdown: UsageByDateBreakdown[],
  dateResolution: ProductUsageBreakdownDateResolution,
): Record<string, number | string>[] {
  const normalizedUsageByDateBreakdown = normalizeUsageDataByDateResolution(
    usageByDateBreakdown,
    dateResolution,
  );

  return normalizedUsageByDateBreakdown.map((usageByDate) => buildNewChartDataPoint(usageByDate));
}

function buildNewChartDataPoint(
  usageByDate: NormalizedProductUsageDataBreakdown,
): Record<string, number | string> {
  const dateData = buildDateProductUsageChartDataItem(usageByDate);

  return {
    [PRODUCT_USAGE_CHART_DATA_KEY]: usageByDate.date,
    ...dateData,
  };
}
